export const orgTeam = [{
    key: 'team_name',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'team_name',
        label: 'Name',
        placeholder: 'Team Name Pvt Ltd'
    },
    validation: {
        required: true,
        message: "is required"
    },

},
{
    key: 'team_id',
    type: 'select',
    value: '',
    valid: false,
    elementConfig: {
        name: 'team_name',
        label: 'Parent Team',
        options: [],
    },
    validation: {
        required: true,
        message: "is required"
    }
},
// {
//     key: 'batch',
//     type: 'select',
//     value: '',
//     valid: false,
//     elementConfig: {
//         name: 'assessment_batches__batch_name',
//         label: 'Batch Name',
//         options: [],
//     },
//     validation: {
//         required: true,
//         message: "is required"
//     }
// }
]

export const editOrgTeam = [{
    key: 'team_name',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'team_name',
        label: 'Name',
        placeholder: 'Team Name Pvt Ltd'
    },
    validation: {
        required: true,
        message: "is required"
    },

},
{
    key: 'team_id',
    type: 'select',
    value: '',
    valid: false,
    elementConfig: {
        name: 'team_name',
        label: 'Parent Team',
        options: [],
    },
    validation: {
        required: true,
        message: "is required"
    }
}
]

export const memberLevels = [
    {
        key: 'member_level',
        type: 'number',
        value: '',
        valid: false,
        elementConfig: {
            name: 'member_level',
            label: 'Member Level',
            placeholder: ''
        },
        validation: {
            required: true,
            min: 1,
            max: 99,
            message: "Please enter Member Level (between 1 to 99)"
        },

    },
]

export const differentTeams = [
    {
        key: 'team_id',
        type: 'select',
        value: '',
        valid: false,
        elementConfig: {
            name: 'team_name',
            label: 'Parent Team',
            options: [],
        },
        validation: {
            required: true,
            message: "is required"
        }
    }
]
export const addPaUsersFd = [
    //     {
    //     key: 'email_Id',
    //     type: 'textarea',
    //     value: '',
    //     valid: false,
    //     elementConfig: {
    //         name: 'email_Id',
    //         label: "Email IDs",
    //         placeholder: ''
    //     },
    //     validation: {
    //         required: true,
    //         message: "is required"
    //     },

    // }
    {
        key: 'email',
        type: 'email',
        value: '',
        valid: false,
        elementConfig: {
            name: 'email',
            label: 'Email Id',
            placeholder: ''
        },
        validation: {
            required: true,
            message: "is required"
        },

    },
]

export const paUserPermissions = [
    {
        key: 'permission_id',
        type: 'select',
        value: '',
        valid: false,
        elementConfig: {
            name: 'permission_name',
            label: 'Permission',
            options: [{
                permission_id: '1',
                permission_name: 'Allow Access'
            }, {
                permission_id: '2',
                permission_name: 'Deny Access'
            }],
        },
        validation: {
            required: true,
            message: "is required"
        }
    }
]

export const teamName = [
    {
        name: 'abc@softrade.in',
        id: '1734'
    },
    {
        name: 'Anish Philip',
        id: '1760'
    },
    {
        name: 'arun.ravichandran@greatplacetowork.com',
        id: '1755'
    },
    {
        name: 'Asha Sridhar',
        id: '1786'
    },
    {
        name: 'babuji.abraham@greatplacetowork.com',
        id: '1756'
    },
    {
        name: 'Deepa Jagan',
        id: '1763'
    },
]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/formData.js